export default __webpack_public_path__ + "static/media/eros.2f6c4341.jpg";